import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

// libs
import { environment } from "@mypxplat/xplat/core";

// app
import { AppModule } from "./app/app.module";
import { configureCognito } from "../../../cognitoConfig";

if (environment.production) {
  enableProdMode();
}

configureCognito(environment.mypresonusUrl + "login", environment.mypresonusUrl + "logout");

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.log(err));
